import { render, staticRenderFns } from "./PictureProduct.template.vue?vue&type=template&id=1cda2578&scoped=true&"
var script = {}
import style0 from "./PictureProduct.template.vue?vue&type=style&index=0&id=1cda2578&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cda2578",
  null
  
)

export default component.exports